import React, {useState} from "react";
import CustomAssignedItems from "../../../../components/CustomAvailableAssignedItems/CustomAssignedItems";
import AssignedSectionTitle from "../../../../components/CustomAvailableAssignedItems/SubComponents/AssignedSectionTitle";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {VIEW_TYPE} from "../../../../enums/ViewType";

/**
 * Read-only section of the zones or the guards of a zone access, paged and searched on the service.
 *
 * @param {string} zoneAccessId Zone access whose items are listed.
 * @param {string} model Search model of the assigned items.
 * @param {string} keyId Key that identifies an item.
 * @param {string} title Title of the section.
 * @param {Component} Icon Icon of the title.
 * @param {string} labelRowsPerPage Label of the page size.
 * @param {string} searchTitle Label of the search.
 * @param {string} tableNotInformationLegend Message shown when nothing is assigned.
 * @param {Function} renderAssignedItem Renders an item, see CustomAssignedItems.
 */
const ZoneAccessAssignedSection = ({
                                       zoneAccessId,
                                       model,
                                       keyId,
                                       title,
                                       Icon,
                                       labelRowsPerPage,
                                       searchTitle,
                                       tableNotInformationLegend,
                                       renderAssignedItem
                                   }) => {
    const [results, setResults] = useState(null);
    const [searchElement, setSearchElement] = useState('');
    const [modified, setModified] = useState(false);
    const [selected, setSelected] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [, setSearch] = useState(false);
    const [, setSimpleSearch] = useState(false);
    const [, setBodyForExport] = useState(null);

    return (
        <CustomAssignedItems
            setBodyForExport={setBodyForExport}
            results={results}
            setResults={setResults}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            selected={selected}
            setSelected={setSelected}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            labelRowsPerPage={labelRowsPerPage}
            tableNotInformationLegend={tableNotInformationLegend}
            tableBuildBody={({page, rowsPerPage, searchElement}) => ({
                body: SEARCH_MODEL.setObject({
                    page,
                    size: rowsPerPage,
                    model,
                    key: searchElement,
                    modelId: zoneAccessId,
                }),
            })}
            tableEndPoint={SimpleSearch}
            keyId={keyId}
            viewTypeName={VIEW_TYPE.GRID.name}
            onDelete={undefined}
            checkbox={false}
            searchTitle={searchTitle}
            renderAssignedItem={renderAssignedItem}
            renderModuleTitle={<AssignedSectionTitle Icon={Icon} title={title}/>}
            autoHeight={false}
        />
    );
};

export default ZoneAccessAssignedSection;
